import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-bl',
  templateUrl: './bl.component.html',
  styleUrls: ['./bl.component.scss']
})
export class BlComponent implements OnInit {

  page: Object;
  
  constructor(private contentService: ContentService) { 
  }

  ngOnInit() {
    this.page = this.contentService.pages['bl'];
  }

}
